<template>
  <product-accordions
    v-if="product?.details"
    :allow-opened-accordions="$feature.allowOpenedDetailsAccordionsOnPDP"
    :description="product.elevatedPDPDetails?.byLineCopy2"
    :heading="product.elevatedPDPDetails?.byLineCopy1"
    :product-details="product.details"
  />
</template>

<script lang="ts" setup>
const { product } = usePdp()
</script>
